<div style="height: inherit">
    <div style="padding: 0%; height: inherit" class="col-md-12 action-buttons text-right">
        <button (click)="confirmPublishChanges()" [disabled]="isDisabled()" class="btn btn-primary" accesskey="p">{{l(actionButtonStructure.componentSettings.actionButtonLabelKey)}}</button>
    </div>
</div>